import { SafePromise } from '@benzinga/safe-await';
import { Session, RestfulClient } from '@benzinga/session';
import { FormattedVideoItem, VideosResponse, YoutubeClearCacheAction } from './entities';
import { VideosEnvironment } from './environment';

export class VideosRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(VideosEnvironment).url, session, { 'x-device-key': true });
  }

  getFeaturedVideos = (): SafePromise<VideosResponse> => {
    const hostname = this.session.getEnvironment(VideosEnvironment).toolsUrl;
    const url = this.URL(`${hostname}watch`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin', timeout: 30000 });
  };

  getYouTubePlaylist = (
    id: string,
    options?: {
      maxResults?: number;
      type?: 'any' | 'video' | 'shorts';
    },
  ): SafePromise<FormattedVideoItem[]> => {
    const url = this.URL(`api/videos/youtube-playlists`, {
      maxResults: options?.maxResults,
      playlistIds: id,
      type: options?.type,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin', timeout: 30000 });
  };

  resetYouTubeCache = ({
    action,
    keys,
    pattern,
  }: {
    action: YoutubeClearCacheAction;
    keys?: string[];
    pattern?: string;
  }): SafePromise<FormattedVideoItem[]> => {
    const url = this.URL(`api/videos/youtube-cache`, {
      action,
      keys,
      pattern,
    });
    return this.post(
      url,
      {},
      {
        allowsAnonymousAuth: true,
        credentials: 'same-origin',
        headers: {
          'x-api-key': this.session.getEnvironment(VideosEnvironment).localYoutubeKey,
        },
        timeout: 3000,
      },
    );
  };
}
